(() => {
  'use strict';
  const ready = new WeakSet();
  function closeDialog(dialog) { if (dialog?.open) dialog.close(); }
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const opener = target.closest('[data-dialog-open]');
    if (opener) document.getElementById(opener.dataset.dialogOpen)?.showModal();
    if (target.closest('[data-dialog-close]')) closeDialog(target.closest('dialog'));
    if (target instanceof HTMLDialogElement) {
      const box = target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(target);
    }
    if (target.closest('.menu-dialog a')) closeDialog(target.closest('dialog'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown[open]').forEach(el => el.removeAttribute('open'));
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nav-dropdown[open]').forEach(el => { if (!el.contains(event.target)) el.removeAttribute('open'); });
  });
  function init(root = document) {
    root.querySelectorAll("[data-country-select]").forEach(select => { if (select.dataset.default) select.value = select.dataset.default; });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (ready.has(section)) return;
      ready.add(section);
      const form = section.querySelector('.personalize-form');
      if (!form) return;
      const variants = form.querySelector('[data-variant-select]');
      const quantity = form.querySelector('[name="quantity"]');
      const names = form.querySelector('[data-names-input]');
      function showImage(src, alt) {
        if (!src) return;
        section.querySelectorAll('[data-main-image], [data-zoom-image]').forEach(image => { image.src = src; image.alt = alt || ''; });
        section.querySelectorAll('[data-gallery-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryImage === src)));
      }
      function summary() {
        const color = form.querySelector('[name="properties[Linen color]"]:checked');
        const motif = form.querySelector('[name="properties[Embroidery motif]"]');
        const style = form.querySelector('[name="properties[Lettering style]"]:checked');
        const thread = form.querySelector('[name="properties[Thread color]"]:checked');
        const date = form.querySelector('[name="properties[Date]"]');
        const selectedColor = form.querySelector('[data-selected-color]');
        if (selectedColor) selectedColor.textContent = color?.value || '';
        const count = form.querySelector('[data-name-count]');
        if (count) count.textContent = `${names?.value.length || 0}/50`;
        const output = form.querySelector('[data-personalization-summary]');
        const withWord = (value, word) => value ? (value.toLowerCase().includes(word) ? value : `${value} ${word}`) : '';
        if (output) output.textContent = [withWord(color?.value, 'linen'), motif?.value, style?.value, withWord(thread?.value, 'thread'), names?.value.trim() || 'Your names', date?.value.trim()].filter(Boolean).join(' · ') + ' — embroidered to order';
      }
      function updateVariant(updateURL = false) {
        const selected = variants?.selectedOptions[0];
        if (!selected) return;
        const available = selected.dataset.available === 'true';
        const add = form.querySelector('[data-add-to-cart]');
        if (add) {
          add.disabled = !available;
          const label = add.querySelector('[data-add-label]');
          if (label) label.textContent = available ? 'Add to bag' : 'Sold out'; else add.textContent = available ? 'Add to bag' : 'Sold out';
        }
        // Price appears twice: in the price row and inside the Add to bag button (as in the original design).
        section.querySelectorAll('[data-product-price], [data-button-price]').forEach(el => { el.textContent = selected.dataset.price; });
        form.querySelector('[data-product-status]').textContent = available ? '' : 'This option is currently unavailable.';
        quantity.min = selected.dataset.min || '1';
        quantity.step = selected.dataset.step || '1';
        if (selected.dataset.max) quantity.max = selected.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        showImage(selected.dataset.image, selected.dataset.alt);
        if (updateURL) {
          const url = new URL(location.href);
          url.searchParams.set('variant', selected.value);
          history.replaceState({}, '', url);
        }
      }
      section.querySelectorAll('[data-gallery-image]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.galleryImage, button.dataset.galleryAlt)));
      form.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
        if (button.dataset.quantityChange === '1') quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      variants?.addEventListener('change', () => updateVariant(true));
      names?.addEventListener('input', () => names.setCustomValidity(''));
      form.addEventListener('input', summary);
      form.addEventListener('change', summary);
      form.addEventListener('submit', event => {
        if (names && !names.value.trim()) { names.setCustomValidity('Please enter the names you would like embroidered.'); names.reportValidity(); event.preventDefault(); return; }
        if (variants?.selectedOptions[0]?.dataset.available !== 'true') { event.preventDefault(); return; }
        // Standard Shopify POST preserves properties and lets Shopify validate stock and prices.
      });
      updateVariant(); summary();
    });
    root.querySelectorAll('[data-reviews]').forEach(section => {
      if (ready.has(section)) return;
      ready.add(section);
      let index = 0;
      const slides = [...section.querySelectorAll('[data-review]')];
      const dots = [...section.querySelectorAll('[data-review-index]')];
      function select(next) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide,i) => { slide.hidden = i !== index; });
        dots.forEach((dot,i) => { dot.classList.toggle('active', i === index); dot.setAttribute('aria-pressed', String(i === index)); });
      }
      section.querySelector('[data-review-prev]')?.addEventListener('click', () => select(index-1));
      section.querySelector('[data-review-next]')?.addEventListener('click', () => select(index+1));
      dots.forEach((dot,i) => dot.addEventListener('click', () => select(i)));
      section.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-review]');
        if (slide) select(slides.indexOf(slide));
      });
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
